<template>
  <div style="overflow: hidden">
    <vs-row>
      <vs-col
        vs-justify="center"
        vs-align="center"
        vs-w="12"
        style="margin-bottom: 5px"
      >
        توضیحات سفارش:
        <vs-textarea
          v-model="orderDescriptions"
          placeholder="توضیحات سفارش را اینجا بنویسید..."
          class="w-100 mt-1"
        />
      </vs-col>
      <vs-col style="padding: 0; padding-right: 15px" vs-w="4.5">
        <vs-radio
          class="radio"
          vs-value="indoor"
          v-model="orderType"
          @input="onTypeChanged"
        >
          داخل سالن</vs-radio
        >
      </vs-col>
      <vs-col style="padding: 0 5px" vs-w="3">
        <vs-radio
          class="radio"
          vs-value="outdoor"
          v-model="orderType"
          @input="onTypeChanged"
        >
          ارسالی</vs-radio
        >
      </vs-col>
      <vs-col style="padding: 0; padding-left: 15px" vs-w="4.5">
        <vs-radio
          class="radio"
          vs-value="takeaway"
          v-model="orderType"
          @input="onTypeChanged"
        >
          تحویل در محل
        </vs-radio>
      </vs-col>
      <vs-col
        v-if="orderType === 'indoor'"
        class="flex"
        vs-justify="center"
        vs-align="center"
        vs-w="12"
      >
        <div
          v-if="tables && Array.isArray(tables) && tables.length > 0"
          style="width: 100%; display: flex"
        >
          <vs-col v-if="table" vs-w="8" class="m-0 p-0">
            <vs-input
              v-model="table.title"
              :disabled="true"
              placeholder="لطفا شماره میز را اینجا وارد نمایید"
              class="w-full mt-1"
            />
          </vs-col>
          <vs-col vs-w="4" class="m-0">
            <vs-button @click="tablesListVisible = true" block>
              شماره میزها
            </vs-button>
          </vs-col>
        </div>
        <div v-else style="width: 100%">
          شماره میز:
          <vs-input
            v-model="deskNumber"
            placeholder="لطفا شماره میز مشتری را اینجا وارد نمایید"
            class="w-100 mt-1"
          />
          <div class="mt-2">
            <span style="font-size: 12px">
              در این قسمت امکان ثبت و مدیریت میزهای خود را دارید.
            </span>
            <router-link to="/tables">
              <vs-button block size="small">مدیریت میزها</vs-button>
            </router-link>
          </div>
        </div>
      </vs-col>
      <vs-col
        v-else-if="orderType === 'outdoor' || orderType === 'takeaway'"
        vs-justify="center"
        vs-align="center"
        :vs-w="orderType === 'outdoor' ? '9' : '12'"
      >
        آدرس:
        <vs-input
          v-model="address"
          @input="onAddressChanged"
          :disabled="orderType === 'takeaway'"
          placeholder="لطفا آدرس مشتری را اینجا وارد نمایید"
          class="w-100 mt-1"
        />
        <div v-if="orderType === 'outdoor'" class="mt-3">
          هزینه پیک (ریال):
          <vs-input
            v-model="deliveryFee"
            placeholder="هزینه پیک"
            class="w-100 mt-1"
          />
        </div>
      </vs-col>
      <vs-col v-if="orderType === 'outdoor'" vs-w="3" class="mt-8 mb-0">
        <vs-button @click="providerZonesVisible = true" block size="small">
          لیست مناطق</vs-button
        >
      </vs-col>
      <vs-col style="padding: 0 15px 0 5px" vs-w="6">
        <vs-radio
          class="radio"
          vs-value="percentage"
          v-model="discountType"
          @input="onDiscountTypeChanged"
        >
          تخفیف درصدی</vs-radio
        >
      </vs-col>
      <vs-col style="padding: 0; padding-left: 15px" vs-w="6">
        <vs-radio
          class="radio"
          vs-value="amount"
          v-model="discountType"
          @input="onDiscountTypeChanged"
        >
          تخفیف قیمتی</vs-radio
        >
      </vs-col>
      <vs-col style="margin-bottom: 30px">
        <h6>تخفیف سفارش:</h6>
        <vs-input
          v-model="discount"
          :placeholder="
            discountType === 'percentage' ? 'تخفیف درصدی' : 'تخفیف قیمتی'
          "
          class="w-100 mt-2"
          type="number"
        />
      </vs-col>
      <invoice-element title="مجموع سفارش" :value="getSum()" />
      <invoice-element
        v-if="discount > 0"
        title="تخفیف"
        :value="getDiscountAmount()"
      />
      <invoice-element
        v-if="addVat"
        :title="'مالیات بر ارزش افزوده ' + `(${TAX_LABEL})`"
        :value="getTax()"
      />
      <invoice-element
        title="هزینه پیک"
        :value="getDeliveryFee()"
        :orderType="orderType"
        :isDelivery="true"
      />
      <invoice-element title="مبلغ پرداختی" :value="getPaidPrice()" />
      <vs-col style="margin-bottom: 15px">
        <select-user ref="selectUserRef" v-model="user"></select-user>
      </vs-col>
    </vs-row>
    <div class="flex justify-start" style="margin-top: 20px">
      <vs-button
        @click="confirmOrder()"
        color="success"
        class="mt-5"
        block
        icon-pack="feather"
        icon="icon-check"
        >تایید و ثبت نهایی سفارش</vs-button
      >
      <vs-button
        v-if="
          providerInfo.hasActivePaymentGateway &&
          user &&
          user.phone &&
          user.phone.length === 11
        "
        @click="sendOrderLink()"
        color="primary"
        class="mt-5 ml-3"
        block
        icon-pack="feather"
        icon="icon-send"
      >
        ارسال فاکتور و لینک پرداخت</vs-button
      >
    </div>

    <vs-popup title="مناطق سرویس دهی" :active.sync="providerZonesVisible">
      <provider-zones-list @selectZone="selectZone" />
    </vs-popup>

    <vs-popup title="لیست شماره میزها" :active.sync="tablesListVisible">
      <tables-list @onTableSelected="onTableSelected" :tables="tables" />
    </vs-popup>

    <vs-popup
      title="انتخاب زمان ارسال سفارش"
      :active.sync="showChooseTimePopup"
    >
      <preparation-time ref="preparationTime" />
      <vs-button
        @click="submitOrder()"
        class="mt-4"
        color="primary"
        type="filled"
        >تائید نهایی سفارش</vs-button
      >
    </vs-popup>
  </div>
</template>

<script>
import orderApiService from "../../../../services/api/OrderApiService";
import { mapGetters } from "vuex";
import InvoiceElement from "./InvoiceElement.vue";
import SelectUser from "../SelectUser.vue";
import providerApiService from "../../../../services/api/ProviderApiService";
import ProviderZonesList from "./ProviderZonesList.vue";
import PreparationTime from "../../PreparationTime.vue";
import { convertToEnglishDigit } from "../../../../helpers/Functions";
import { TAX_FEE, TAX_LABEL } from "../../../../helpers/Constants";
import TablesList from "./TablesList.vue";

export default {
  components: {
    InvoiceElement,
    SelectUser,
    ProviderZonesList,
    PreparationTime,
    TablesList,
  },
  name: "Category",
  data() {
    const orderType = localStorage.getItem("orderType");

    return {
      orderDescriptions: "",
      deskNumber: "", // This should be removed after a while
      table: null,
      tables: [],
      address: "",
      orderType: orderType || "indoor",
      discountType: "percentage",
      deliveryZone: null,
      deliveryFee: null,
      addVat: false,
      user: null,
      discount: null,
      providerZonesVisible: false,
      providerInfo: {},
      showChooseTimePopup: false,
      tablesListVisible: false,
      TAX_LABEL,
      cart: { ...this.shoppingCardInfo },
    };
  },
  created() {
    if (this.order) {
      this.user = this.order.user;
    }
    if (this.order) {
      this.orderType = this.order.type;
      this.orderDescriptions = this.order.userDetails.description;

      if (this.order.discount) {
        this.discount = this.getDiscountPercentage(
          this.order.price,
          this.order.discount
        );
      }

      if (this.order.type === "indoor") {
        this.deskNumber = this.order.userDetails?.destination; // This should be removed after a while
        this.table = this.order.table;
      } else {
        this.address = this.order.userDetails.destination;
        if (this.order.userDetails.delivery) {
          this.deliveryFee = +this.order.userDetails.delivery.fee
            .toString()
            .splitNumberFormat();
        }

        if (this.order.userDetails.destination === "تحویل در محل مجموعه") {
          this.takeInProviderPlace = true;
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  props: {
    shoppingCardInfo: {
      type: Object,
      requried: true,
    },
    order: {
      type: Object,
    },
  },
  watch: {
    discount(newValue) {
      if (this.discountType === "percentage") {
        if (newValue < 0) {
          this.discount = null;
        } else if (newValue >= 0 && newValue <= 100) {
          this.discount = convertToEnglishDigit(newValue);
        } else if (newValue > 100) {
          this.discount = 100;
        }
      } else {
        this.discount = convertToEnglishDigit(newValue);
      }
    },
    deliveryFee(newValue) {
      this.deliveryFee = convertToEnglishDigit(newValue)
        .toString()
        .splitNumberFormat()
        .numberFormat();
    },
    orderType(newValue) {
      localStorage.setItem("orderType", newValue);
    },
  },
  methods: {
    getProviderTables() {
      providerApiService
        .getProviderTablesList(this.currentProvider.id)
        .then((result) => {
          this.tables = result.data;
        });
    },
    resetData() {
      this.orderDescriptions = "";
      this.deskNumber = ""; // This should be removed after a while
      this.table = null;
      this.address = "";
      this.orderType = "indoor";
      this.deliveryZone = null;
      this.deliveryFee = null;
      this.user = null;
      this.discount = null;
      this.providerZonesVisible = false;
      this.showChooseTimePopup = false;

      this.$refs["selectUserRef"].clear();
    },
    onTypeChanged(type) {
      if (type !== "outdoor") {
        this.deliveryZone = null;
        this.deliveryFee = null;
      }
      if (type === "takeaway") {
        this.address = "تحویل در محل مجموعه";
      } else {
        this.address = "";
      }
    },
    onDiscountTypeChanged() {
      this.discount = null;
    },
    onAddressChanged(value) {
      if (value.length === 0) {
        this.deliveryZone = null;
      }
    },
    getSum() {
      let price = 0;
      this.shoppingCardInfo.products.forEach((element) => {
        const discount = element.product.discount || 0;
        const finalPrice =
          element.product.price - element.product.price * (discount / 100);
        price += finalPrice * element.unit;
      });
      return price;
    },
    getDiscountAmount() {
      let discount = 0;
      if (this.discountType === "percentage") {
        discount = this.getSum() * (+this.discount / 100);
      } else {
        discount = +this.discount;
      }
      return discount;
    },
    getDiscountPercentage(price, discount) {
      const discountPercentage = Math.floor((price + discount) / discount);
      return discountPercentage;
    },
    getTax() {
      if (!this.addVat) {
        // When tax calculation is not enabled in settings
        return 0;
      }

      const sum = this.getSum();
      let tax = sum * TAX_FEE;
      return tax;
    },
    getDeliveryFee() {
      return this.deliveryFee
        ? +this.deliveryFee.toString().splitNumberFormat()
        : 0;
    },
    getPaidPrice() {
      return (
        this.getSum() +
        this.getTax() +
        this.getDeliveryFee() -
        this.getDiscountAmount()
      );
    },
    confirmOrder() {
      if (this.orderType === "outdoor") {
        this.showChooseTimePopup = true;
        return;
      }

      this.submitOrder();
    },
    submitOrder() {
      this.createOrder(
        "approved",
        "offline",
        this.orderType === "outdoor"
          ? this.$refs.preparationTime?.getTime()
          : null
      )
        .then((res) => {
          this.$emit("close");
          this.resetData();

          this.$vs.notify({
            text: res.message,
            color: "success",
            position: "bottom-center",
          });

          setTimeout(() => {
            if (this.order) {
              // Edit order callback
              this.$router.replace("/order/list");
            } else {
              // Create order callback
              this.$emit("resetData");
            }
          }, 100);
        })
        .catch(() => {})
        .finally(() => this.$vs.loading.close());
    },
    createOrder(status, paymentType, preparationTime) {
      return new Promise((resolve, reject) => {
        const { orderDescriptions, deskNumber, table, address, orderType } =
          this;

        if (!orderType) {
          this.$vs.notify({
            text: "لطفا نوع سفارش را انتخاب کنید",
            color: "warning",
            position: "bottom-center",
          });
          return reject();
        }

        if (orderType === "indoor" && deskNumber === "" && !table) {
          this.$vs.notify({
            text: "لطفا شماره میز را وارد کنید",
            color: "warning",

            position: "bottom-center",
          });
          return reject();
        }

        if (orderType === "outdoor") {
          if (address === "") {
            this.$vs.notify({
              text: "لطفا آدرس را وارد کنید",
              color: "warning",
              position: "bottom-center",
            });
            return reject();
          }
        }

        /**
         * Allow sending print notification when creating order.
         */
        let sendPrintNotification = true;

        /**
         * Prevent sending notification when editing order.
         */
        if (this.order?.id) {
          sendPrintNotification = false;

          /**
           * Allow sending notification when any items has changed
           */
          if (
            this.areArraysDifferent(
              this.cart.products,
              this.shoppingCardInfo.products
            )
          ) {
            sendPrintNotification = true;
          }
        }

        this.$vs.loading();

        orderApiService
          .createOrEditOrder(
            this.order ? this.order.id : null,
            this.currentProvider.id,
            this.user ? this.user.phone : null,
            this.getSum(),
            this.getDiscountAmount(),
            this.shoppingCardInfo.products,
            orderDescriptions,
            deskNumber,
            table?.id,
            address,
            orderType,
            this.deliveryFee,
            status,
            paymentType,
            preparationTime,
            true, // isIntentionalChange
            sendPrintNotification
          )
          .then(resolve)
          .catch((err) => {
            this.$vs.notify({
              text: err.getErrorDescriptions(),
              color: "danger",
              position: "bottom-center",
            });

            this.$vs.loading.close();
            reject(err);
          });
      });
    },
    sendOrderLink() {
      if (this.user && this.user.phone.length !== 11) {
        this.$vs.notify({
          text: "لطفا شماره همراه کاربر را به صورت کامل وارد نمایید.",
          color: "warning",
          position: "bottom-center",
        });
        return;
      }

      this.createOrder("payment_required", "online")
        .then((orderResult) => {
          orderApiService
            .sendOrderLink(this.currentProvider.id, orderResult.resource.id)
            .then((res) => {
              this.$emit("close");
              this.resetData();

              this.$vs.notify({
                text: res.message,
                color: "success",
                position: "bottom-center",
              });

              setTimeout(() => {
                if (this.order) {
                  // Edit order callback
                  this.$router.replace("/order/list");
                } else {
                  // Create order callback
                  this.$emit("resetData");
                }
              }, 100);
            })
            .catch((err) => {
              this.$vs.notify({
                text: err?.getErrorDescriptions(),
                color: "danger",
                position: "bottom-center",
              });
            })
            .finally(() => {
              this.$vs.loading.close();
            });
        })
        .catch(() => {});
    },
    getProviderSettings() {
      providerApiService.getSettings(this.currentProvider.id).then((result) => {
        result?.forEach((element) => {
          if (element.key === "calculate-vat") {
            this.addVat = element.value;
          }
        });
      });
    },
    getProviderInfo() {
      providerApiService
        .providerProfile(this.currentProvider.id)
        .then((providerInfo) => {
          this.providerInfo = providerInfo;
        });
    },
    selectZone(zone) {
      this.providerZonesVisible = false;

      if (this.deliveryZone) {
        const zoneLength = this.deliveryZone.title.length;
        const _text = this.address.substring(zoneLength + 3);
        this.address = _text;
      }

      this.address = zone.title + " - " + this.address;
      this.deliveryFee = zone.fee;
      this.deliveryZone = zone;
    },
    onTableSelected(table) {
      this.tablesListVisible = false;
      this.table = table;
    },
    areArraysDifferent(arr1, arr2) {
      // Check if the lengths are different
      if (arr1.length !== arr2.length) {
        return true;
      }

      // Sort arrays by product ID (assuming product.id exists)
      arr1.sort((a, b) => a.product.id - b.product.id);
      arr2.sort((a, b) => a.product.id - b.product.id);

      // Compare each element in both arrays
      for (let i = 0; i < arr1.length; i++) {
        // Check if the product.id or unit are different
        if (
          arr1[i].product.id !== arr2[i].product.id ||
          arr1[i].unit !== arr2[i].unit
        ) {
          return true;
        }
      }

      // If no differences found
      return false;
    },
  },
  mounted() {
    this.getProviderSettings();
    this.getProviderInfo();
    this.getProviderTables();
  },
};
</script>

<style scoped lang="scss">
.radio {
  border: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  width: 100%;

  @media (max-width: 500px) {
    font-size: 0.8rem;
  }
}
</style>
